import React, { Component } from 'react'
import { Link } from 'react-router'
import { findDOMNode } from 'react-dom'
import onClickOutside from 'react-onclickoutside'
import mousetrap from 'mousetrap'

import classNames from './AlbumPicker.css'
import Icon from '../Icon'

class AlbumPicker extends Component {
  state = {
    text: this.props.initialValue || '',
    showAlbumList: false,
    selected: -1
  }
  componentDidMount () {
    this.node = findDOMNode(this)
    mousetrap.bind('up', this.onKeyUp)
    mousetrap.bind('down', this.onKeyDown)
    mousetrap.bind('escape', this.clearSearch)
  }
  componentDidUpdate (prevProps, prevState) {
    const { selected } = this.state
    if (prevState.selected !== selected) {
      const button = this.node.querySelectorAll('.' + classNames.autoCompleteItem)[selected].parentNode
      button && button.focus()
    }
  }
  componentWillUnmount () {
    mousetrap.unbind(['up', 'down', 'escape'])
  }
  onKeyDown = e => {
    e.preventDefault()
    this.setState({ selected: this.state.selected + 1 })
  }
  onKeyUp = e => {
    e.preventDefault()
    if (this.state.selected === 0) {
      this.refs.search.focus()
    }
    this.setState({ selected: Math.max(-1, this.state.selected - 1) })
  }
  handleClickOutside = () => {
    this.setState({
      showAlbumList: false,
      selected: -1
    })
    this.refs.search && this.refs.search.blur()
  }
  onChangeText = e => {
    this.setState({
      text: e.target.value,
      selected: -1
    })
  }
  selectAlbum = (key, name) => {
    const { onChange, resetOnChange, collapseOnSelect } = this.props
    onChange(key)
    this.setState({
      text: resetOnChange ? '' : name,
      showAlbumList: collapseOnSelect ? false : !!resetOnChange,
      selected: -1
    })
    if (resetOnChange && !collapseOnSelect) {
      this.refs.search.focus()
    }
  }
  showAlbumList = () => {
    this.setState({
      showAlbumList: true
    })
  }
  clearSearch = () => {
    const { onChange, resetOnChange } = this.props
    if (!resetOnChange) {
      onChange(undefined)
    }
    this.setState({
      text: '',
      selected: -1,
      showAlbumList: false
    })
    this.refs.search.blur()
  }
  searchString = (substring, string) => {
    return string.toLowerCase().indexOf(substring.toLowerCase()) !== -1
  }
  renderAlbumLists = (lists, albums, text) => {
    const { exclude } = this.props
    let nodes = []
    for (let list of lists) {
      const matches = list.albums.filter(album => {
        if (exclude && exclude.indexOf(album.id) !== -1) return false
        return this.searchString(text, album.name)
      })
      if (matches.length !== 0) {
        nodes.push(<li key={'list' + list.id} className={classNames.autoCompleteHeading}>{list.name}</li>)
        nodes = nodes.concat(matches.map(this.renderAlbum))
      }
    }
    return nodes
  }
  renderAlbum = ({ id, name, cover }) => {
    const { getImageSource } = this.props
    const onClick = () => this.selectAlbum(id, name)
    return (
      <li>
        <button onClick={onClick} style={{ width: '100%' }}>
          <div className={classNames.autoCompleteItem}>
            {getImageSource &&
              <div
                className={classNames.cover}
                style={{ backgroundImage: `url(${this.props.getImageSource(cover)})` }}
              />
            }
            {name}
          </div>
        </button>
      </li>
    )
  }
  renderAutocomplete = () => {
    const { albums, lists, exclude, isOwner } = this.props
    const { text } = this.state

    const saved = []
    const shared = []

    for (let album of albums) {
      if (!this.searchString(text, album.name)) {
        continue
      }
      if (exclude && exclude.indexOf(album.id) !== -1) {
        continue
      }
      if (isOwner(album)) {
        saved.push(album)
      } else {
        shared.push(album)
      }
    }

    return (
      <ul className={classNames.autoComplete}>
        {this.props.onCreateNewAlbum &&
          <li>
            {this.props.createNewAlbumLink &&
              <Link
                to={{ pathname: '/search', query: { playlist: this.props.playlistID || 'create' } }}
                className={classNames.autoCompleteItem}
                onClick={this.props.onCreateNewAlbum}>
                <div className={classNames.addAlbumCover} />
                Create New Album
              </Link>
            }
            {!this.props.createNewAlbumLink &&
              <button onClick={this.props.onCreateNewAlbum} style={{ width: '100%' }}>
                <div className={classNames.autoCompleteItem}>
                  <div className={classNames.addAlbumCover} />
                  Create New Album
                </div>
              </button>
            }
          </li>
        }
        {lists && this.renderAlbumLists(lists, albums, text)}
        {saved.length !== 0 &&
          <li className={classNames.autoCompleteHeading}>
            All albums
          </li>
        }
        {saved.map(this.renderAlbum)}
        {shared.length !== 0 &&
          <li className={classNames.autoCompleteHeading}>
            Albums shared with you
          </li>
        }
        {shared.map(this.renderAlbum)}
      </ul>
    )
  }
  render () {
    const { text, showAlbumList } = this.state
    return (
      <div className={classNames.wrapper}>
        <input
          type='text'
          value={text}
          onChange={this.onChangeText}
          onClick={this.showAlbumList}
          className={'mousetrap ' + classNames.input}
          placeholder={this.props.placeholder || 'Choose from your albums or create new'}
          ref='search'
        />
        {(text !== '' || showAlbumList) &&
          <button onClick={this.clearSearch} className={classNames.clearButton}>
            <Icon icon='close' />
          </button>
        }
        {showAlbumList &&
          this.renderAutocomplete()
        }
      </div>
    )
  }
}

export default onClickOutside(AlbumPicker)



// WEBPACK FOOTER //
// ./src/components/playlist/AlbumPicker.js